/**
 * Deal/installment ROAS covenant months are stored 1-based in the API
 * (month 1 = first MOB). The UI edits them as 0-based MOB indexes so they
 * match the rest of the product (cohort grids, cashflow MOB 0, etc.).
 */

export function isRoasCovenantMonthSet(month) {
  return month !== '' && month !== null && month !== undefined;
}

/** API 1-based month → UI 0-based MOB. */
export function roasCovenantMonthFromApi(month) {
  if (!isRoasCovenantMonthSet(month)) {
    return '';
  }
  const monthNumber = Number(month);
  if (!Number.isFinite(monthNumber)) {
    return '';
  }
  return monthNumber - 1;
}

/** UI 0-based MOB → API 1-based month. */
export function roasCovenantMonthToApi(month) {
  if (!isRoasCovenantMonthSet(month)) {
    return null;
  }
  const monthNumber = Number(month);
  if (!Number.isFinite(monthNumber)) {
    return null;
  }
  return monthNumber + 1;
}

export function mapRoasThresholdsFromApi(thresholds) {
  return (thresholds ?? []).map((threshold, index) => ({
    id: index + 1,
    month: roasCovenantMonthFromApi(threshold.month),
    minRoasPct: threshold.minRoasPct ?? '',
  }));
}

export function mapRoasThresholdsToApi(thresholds) {
  return (thresholds ?? [])
    .filter(
      (threshold) =>
        isRoasCovenantMonthSet(threshold.month) &&
        threshold.minRoasPct !== '' &&
        threshold.minRoasPct !== null &&
        threshold.minRoasPct !== undefined
    )
    .map((threshold) => ({
      month: roasCovenantMonthToApi(threshold.month),
      minRoasPct:
        typeof threshold.minRoasPct === 'number'
          ? threshold.minRoasPct
          : Number(threshold.minRoasPct),
    }));
}
